import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConverterService } from 'src/app/core/converter.service';
import { EnvironmentService } from 'src/app/core/environment/environment.service';
import { KeywordsListItem } from 'src/app/models/keywords-list-item.model';

export class KeywordsFilters {
  ean: string = null;
  pageNumber = 0;
  pageSize = 50;
}

@Injectable()
export class KeywordsOptimizationService {
  resultsNumber = new Subject<number>();

  constructor(private converter: ConverterService, private http: HttpClient, private environmentService: EnvironmentService) {}

  getKeywords(filters: KeywordsFilters): Observable<KeywordsListItem[]> {
    const ean = filters.ean ?? '';
    const queryPath = `?page=${filters.pageNumber}&size=${filters.pageSize}${ean ? '&ean=' + ean : ''}`;

    return this.http.get(this.environmentService.getRestEndpoint('keywords') + queryPath, { observe: 'response' }).pipe(
      map((resp: HttpResponse<any>) => {
        this.resultsNumber.next(+resp.headers.get('Total-Length'));
        return resp.body;
      }),
      map((resp: KeywordsListItem[]) => resp.map((r) => this.converter.fromJSONtoObj(r, KeywordsListItem)))
    );
  }
}
